module.exports = __webpack_public_path__ + "img/joy.f75f9f3.webp";